// surf_academia — T1 tutorial numa ILHA (mar embaixo = morte). 4 stages:
// descida, transferência (com ATALHO lateral roxo), bhop sobre a água, zig final.
import { Course } from '../course';
import type { GameMap } from '../types';
import { finishMap } from './util';

export function buildAcademia(): GameMap {
  const c = new Course(0, 0, 256, 0);

  // === Stage 1: primeira descida ===
  c.spawnHere(-256);
  c.zoneOver(c.platform(224, 512), 'start');
  c.drop(560);
  c.ramp(640, 512, 4200);
  c.drop(16);
  c.spawnHere(-256);
  c.zoneOver(c.platform(448, 768), 'stage', { index: 2 });

  // === Stage 2: transferência com gap + ATALHO (lane roxa estreita, contínua) ===
  c.drop(560);
  c.mark();
  c.shift(704);
  c.ramp(384, 512, 4624, 'short'); // atalho: sem gap, mas estreito
  c.restore();
  c.ramp(640, 512, 2200);
  c.advance(224); // gap
  c.ramp(640, 512, 2200);
  c.drop(16);
  c.spawnHere(-256);
  c.zoneOver(c.platform(1024, 768), 'stage', { index: 3 }); // pega as duas rotas

  // === Stage 3: bhop sobre o mar ===
  c.bhopGaps(5, 256, 288, 288);
  c.spawnHere(-192);
  c.zoneOver(c.platform(448, 512), 'stage', { index: 4 });

  // === Stage 4: zig lateral final ===
  c.drop(560);
  c.ramp(640, 512, 2600);
  c.shift(-512);
  c.advance(128);
  c.ramp(640, 512, 1600);
  c.drop(16);
  c.zoneOver(c.platform(896, 768, 'accent'), 'end');

  return finishMap(c, 'surf_academia');
}
